export default __webpack_public_path__ + "static/media/ilus8.ad2d85d2.jpeg";